import React, { useState, useEffect } from 'react'; 
import { useAuth } from '../utils/AuthContext/AuthContext';
import { useSelector, useDispatch } from 'react-redux'; 
import { setContracts, setStep, setFormId, setAmendmentId, setFullForm, setAmendmentData } from '../redux/actions';
import AmendDataValidation from '../components/AmendExtend/AmendDataValidation';
import AmendDateChange from '../components/AmendExtend/AmendDateChange';
import AmendAdditional from '../components/AmendExtend/AmendAdditional';
import AmendExtendPacketSign from '../components/PacketSigning/AmendExtendPacketSign';
import ErrorBoundary from '../utils/ErrorBoundary';
import config from '../utils/config'; 

import MainCard from '../components/MainCard';

function AmendExtend() {
    const dispatch = useDispatch(); 
    const [selectedIndex, setSelectedIndex] = useState(null); // State to track selected contract index
    const formId = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.formId ?? '');  
    const amendmentId = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.amendments?.[0]?.amendmentId ?? ''); 
    const amendmentData = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.amendments?.[0] ?? {});
    const fullForm = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex] ?? {});  
    const contracts = useSelector(state => state?.amendment?.amendExtend?.contracts ?? []);
    const step = useSelector(state => state.amendment.amendExtend.step);
    const { token } = useAuth();
    const localToken = localStorage.getItem('token');

useEffect(() => {
    async function fetchData() {
        try {
            const response = await fetch(`${config.apiBaseUrl}/formdata/user`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token || localToken}`
                }
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            dispatch(setContracts(data)); // Dispatch action to update contracts in the Redux store
            // console.log("Contracts in AmendExtend:", data);
        } catch (error) {
            console.error("Error fetching contracts:", error);
        }
    }
    
    fetchData();
}, [dispatch, token]);

// Adjusted nextStep function to accept currentSelectedIndex
const nextStep = (currentSelectedIndex = selectedIndex) => {
    const selectedContract = contracts[currentSelectedIndex];
    if (selectedContract) {
        dispatch(setStep(step + 1)); // Ensure setStep returns a plain object
        // console.log(selectedContract.formId);
    } else {
        console.error(`No contract found at index ${currentSelectedIndex}`);
    }
};

const handleSelectContract = (index) => {
    setSelectedIndex(index); // Update the selected index state
    nextStep(index); // Pass the current index directly
};


// Adjusting prevStep function
const prevStep = () => {
    dispatch(setStep(step - 1)); // Dispatch action to update step in the Redux store
};

const completedContracts = contracts
.map((contract, index) => ({ contract, originalIndex: index }))
.filter(({ contract }) => contract?.packetDetails?.status === 'completed');

    return (
        <div className='mt-12'>
        <MainCard width={750}>
        {step === 0 && (
            <>
                <h1 className='text-lg text-black font-[Inter]'>Choose address from your completed contracts</h1>
                <hr className='bg-slate-700 h-[2px] w-full'></hr>
                {completedContracts.map(({ contract, originalIndex }) => (
                        <div className='flex flex-col gap-2' key={originalIndex}>
                            <button 
                                className='hover:bg-[#f0f0f0] p-2 border rounded-lg border-shi-green'
                                onClick={() => handleSelectContract(originalIndex)}
                            >
                                {(Object.values(contract?.data?.address).join(', '))}
                            </button>
                        </div>
                ))}
            </>
        )}
        {step === 1 && (
            <ErrorBoundary>
                <AmendDataValidation 
                    formId={formId} 
                    prevStep={prevStep} 
                    nextStep={nextStep} 
                    step={step} 
                    amendmentId={amendmentId} 
                    contracts={contracts} 
                    fullForm={fullForm} 
                    amendmentData={amendmentData} 
                    selectedIndex={selectedIndex}
                />
            </ErrorBoundary>
        )}
        {step === 2 && <AmendDateChange formId={formId} prevStep={prevStep} nextStep={nextStep} step={step} setStep={setStep} amendmentId={amendmentId} fullForm={fullForm} amendmentData={amendmentData} selectedIndex={selectedIndex}/>}
        {step === 3 && <AmendAdditional formId={formId} prevStep={prevStep} nextStep={nextStep} step={step} setStep={setStep} amendmentId={amendmentId} fullForm={fullForm} amendmentData={amendmentData} selectedIndex={selectedIndex}/>}
        {step === 4 && <AmendExtendPacketSign formId={formId} prevStep={prevStep} nextStep={nextStep} step={step} setStep={setStep} amendmentId={amendmentId} fullForm={fullForm} amendmentData={amendmentData} selectedIndex={selectedIndex}/>}
        
    </MainCard>
    </div>
    ); 
}

export default AmendExtend;